module.exports = __webpack_public_path__ + "img/nav1.b0226973.png";